import * as React from 'react';
import { Button } from '../../../web/components-v2/Button';
import {
	Dialog,
	DialogPopup,
	DialogHeader,
	DialogTitle,
	DialogDescription,
	DialogFooter,
} from '../../../web/components-v2/Dialog';

export interface ConfirmModalProps {
	title: string;
	message: string;
	confirmLabel?: string;
	cancelLabel?: string;
	onConfirm: () => void;
	onCancel: () => void;
	/** Use 'danger' for destructive actions */
	variant?: 'primary' | 'danger';
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
	title,
	message,
	confirmLabel = 'Confirm',
	cancelLabel = 'Cancel',
	onConfirm,
	onCancel,
	variant = 'primary',
}) => {
	return (
		<Dialog
			open
			onOpenChange={open => {
				if (!open) onCancel();
			}}
		>
			<DialogPopup>
				<DialogHeader>
					<DialogTitle>{title}</DialogTitle>
					<DialogDescription>{message}</DialogDescription>
				</DialogHeader>
				<DialogFooter>
					<Button variant='outline' size='sm' onClick={onCancel}>
						{cancelLabel}
					</Button>
					<Button variant={variant === 'danger' ? 'destructive' : 'primary'} size='sm' onClick={onConfirm}>
						{confirmLabel}
					</Button>
				</DialogFooter>
			</DialogPopup>
		</Dialog>
	);
};
